import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import DateInput from 'Components/UI/BehavioralFormElement/NormalizedInput/Date';

import './index.css';
import moment from 'moment';

const TextDateAlias = ({ className, label, ...props }) => (
  <FloatingLabel className={`Date ${className}`} label={label}>
    <DateInput {...props} />
  </FloatingLabel>
);

TextDateAlias.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.instanceOf(moment),
  ]),
};

TextDateAlias.defaultProps = {
  className: '',
  label: '',
  placeholder: '',
  value: null,
};

export default TextDateAlias;
